import { Component } from '@angular/core';

@Component({
	selector: 'app-public-home',
	templateUrl: './public-home.component.html',
	styleUrls: ['./public-home.component.css'],
	standalone: false,
})
export class PublicHomeComponent {
	constructor() {}
}
